<div class="questions-table">
  <div class="header">
    <span>Field</span>
    <span>Visual Indicator</span>
    <span
      >Visible to <mat-icon matTooltip="Contact support@scoot.app to set up conditional viewing.">info</mat-icon></span
    >
  </div>
  @for (question of overview; track question.title) {
    <div class="badging-overview-question">
      <span>{{ question.title }}</span>
      <!-- TODO: Change to get Visual Indicator -->
      @if (question.title === visualIndicator) {
        <mat-checkbox disabled checked></mat-checkbox>
      }
      <span>{{ getVisibilityTexts(question.visibility) }}</span>
    </div>
  }
</div>
